import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function PauseIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M6 4H11V20H6V4Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M13 4H18V20H13V4Z",
    fill: "currentColor"
  }));
}